import { useState, useCallback, useEffect } from 'react';

export interface SitesFilters {
  search: string;
}

/**
 * Hook to manage sites filter state with debouncing
 * Follows the pattern from useAllocationFilters but with debouncing for search
 * @returns Filter state and update functions
 */
export const useSitesFilters = () => {
  const [search, setSearchImmediate] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  // Debounce search input (300ms delay)
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);

    return () => clearTimeout(timer);
  }, [search]);

  const updateSearch = useCallback((value: string) => {
    setSearchImmediate(value);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchImmediate('');
    setDebouncedSearch('');
  }, []);

  const filters: SitesFilters = {
    search: debouncedSearch,
  };

  return {
    // Current search value (for input binding)
    searchValue: search,
    // Debounced filters (for API calls)
    filters,
    updateSearch,
    clearSearch,
    hasActiveFilters: Boolean(debouncedSearch),
  };
};
